import React from "react";

export default function TermOfServices() {
  return (
    <div className="p-4 d-flex align-items-center justify-content-center">
      <div className="text-dark" style={{ maxWidth: "1000px", width: "95vw" }}>
        <h3>Terms and Conditions of Essay Grad</h3>
        <br />
        <br />
        <h3>Acceptance of Terms</h3>
        <p>
          You recognise and agree to abide by the following terms and conditions
          by utilising our essay writing service. These terms govern the
          relationship between you (referred to as "the client") and our essay
          writing service (referred to as "the company").
        </p>
        <br />
        <h3>Service Description</h3>
        <p>
          Our essay writing service provides custom-written essays, research
          papers, and other academic documents for informational and reference
          purposes only. The client agrees that the delivered content should not
          be submitted as their own work but used as a guide to assist with
          their own writing.
        </p>
        <br />
        <h3>Plagiarism and Academic Integrity</h3>
        <p>
          The client acknowledges that the company's services are intended to be
          used responsibly and in accordance with academic integrity standards.
          The company does not condone plagiarism, cheating, or any form of
          academic dishonesty. The client consents to reference the supplied
          materials and appropriately credit any sources used.
        </p>
        <br />
        <h3>Placement and Payment of Orders</h3>
        <p>
          To place an order, the client must provide accurate and complete
          information regarding the required essay, including topic, word count,
          formatting style, and any specific instructions. All required
          materials and sources must be supplied by the client. While placing an
          order, payment for the assignment must be made in full.
        </p>
        <br />
        <h3>Delivery and Revisions</h3>
        <p>
          The business will try its best to deliver the finished essay by the
          predetermined timeframe. However, we do not ensure particular academic
          results or grades.. The client may request revisions within a
          specified timeframe after receiving the completed essay, provided that
          the revision request aligns with the original instructions.
        </p>
        <h3>Privacy and Confidentiality</h3>
        <p>
          The business takes customer privacy seriously and will manage all
          personal information in compliance with relevant data protection
          legislation. The client's personal information will only be used for
          the purpose of providing the requested services and will not be shared
          with third parties without explicit consent, except as required by
          law.
        </p>
        <br />
        <h3>Refunds and Cancellations</h3>
        <p>
          Refunds may be issued at the company's discretion if the client
          provides evidence of a failure to meet the specified requirements or a
          violation of these terms. Cancellation of an order may be allowed
          within a specified timeframe, subject to the company's cancellation
          policy, which may include a cancellation fee.
        </p>
        <br />
        <h3>Limitation of Liability</h3>
        <p>
          We are not responsible for any punitive, incidental, direct or
          indirect damages as a outcome of incometency or use essaygrad
          service.The customer consents to take on any risks related to
          utilising the service.
        </p>
        <br />
        <h3>Informational property</h3>
        <p>
          All intellectual property rights in connection with the content that
          is provided to the client remain the property of the company. The
          client agrees not to distribute, reproduce, or sell the content
          provided by the company without prior written consent.
        </p>
        <br />
        <h3>Regulations and Applicable Law</h3>
        <p>
          The laws of [Jurisdiction] shall apply to this agreement and be
          followed in interpreting it. The courts only rights for any dispute
          related to mention agreements
        </p>
      </div>
    </div>
  );
}
